import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { CompanyMergeData } from '../data/company.merge.data';
import { EmployeeMergeData } from '../data/employee.merge.data';
import { QuoteProMergeData } from '../data/quote.pro.merge.data';
import { AccountContactMergeData } from '../data/account.contact.merge.data';
import { AccountMergeData } from '../data/account.merge.data';
import { BasicSiteMergeData } from '../data/basic.site.merge.data';
import { QuoteProMergeDataset } from './quote.pro.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.QuoteJob,
    dependsOn: [ActivityEntityName.Job]
})
export class QuoteProJobMergeDataset extends QuoteProMergeDataset {
    public static get empty() {
        return {
            quote: new QuoteProMergeData(),
            quoteOwner: new EmployeeMergeData(),
            quoteContact: new AccountContactMergeData(),
            quoteAccount: new AccountMergeData(),
            quoteSite: new BasicSiteMergeData(),
            quoteCompany: new CompanyMergeData(),
            theme: null
        } as QuoteProJobMergeDataset;
    }
}